import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';


import isEqual from 'lodash/isEqual';

import TiptapGenerated from './TiptapGenerated';
const TiptapRender = loadable(() => import('./TiptapRender.js'));

import getTextContent from './helpers/getTextContent';

import TextEditorWrapper from './styles/TextEditorWrapper';




class TextEditorGenerator extends React.Component {

  constructor(props) {
    super();

    const getState = getTextContent(props);
    
    this.state = {
      editorState: getState.editorState,
      content: getState.content
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const getNewStateCompare = getTextContent(nextProps, true);
    if (!isEqual(prevState.content, getNewStateCompare)) {
      const getNewState = getTextContent(nextProps);
      return {
        editorState: getNewState.editorState,
        content: getNewState.content
      }
    }
    return null;
  }





  render() {
    
    const { editorState } = this.state;

    const { 
      bulletStyling,
      styling,
      viewPort,
      viewRef,
      typeOfStyle,
      frameRef,
      disableLinkEdit,
      isSaving,
      handleIsEditable,
      customStyles,
      isEditor,
      baseUrlTamplate,
      renderSync,
      windowWidth
    } = this.props;

    const TipTapComponent = isEditor ? TiptapRender : TiptapGenerated;

    const generatorContent = (
      <TipTapComponent 
        isEditor={isEditor}
        content={editorState}
        editable={false}
        styling={styling}
        viewPort={viewPort}
        viewRef={viewRef}
        typeOfStyle={typeOfStyle}
        frameRef={frameRef}
        disableLinkEdit={disableLinkEdit}
        isSaving={isSaving}
        handleIsEditable={handleIsEditable}
        customStyles={customStyles}
        baseUrlTamplate={baseUrlTamplate}
        renderSync={renderSync}
        windowWidth={windowWidth}
      />
    )


    if (bulletStyling) {
      return (
        <TextEditorWrapper bulletStyling={bulletStyling}>
          {generatorContent}
        </TextEditorWrapper>
      );
    }

    return generatorContent;

  }
}

TextEditorGenerator.propTypes = {
  typeOfStyle: PropTypes.string,
  content: PropTypes.object,
  componentPayload: PropTypes.object,
  language: PropTypes.string,
  defaultValues: PropTypes.object,
};

export default TextEditorGenerator;